import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BootstrapSpinner from 'react-bootstrap/Spinner';
import './spinner.scss';

const Spinner = (props) => {
  const {
    spinnerContainerClass,
    isLoading,
    isAbsolute,
    elementType,
    animation,
    size,
    colorVariant,
    className,
    children,
  } = props;

  return (
    <div
      data-testid='spinner-container'
      className={classNames(spinnerContainerClass, {
        'd-none': !isLoading,
        'spinner-absolute-container': isAbsolute,
      })}
    >
      <BootstrapSpinner
        data-testid='spinner'
        as={elementType}
        animation={animation}
        size={size}
        variant={colorVariant}
        className={className}
      >
        {children}
      </BootstrapSpinner>
    </div>
  );
};

Spinner.propTypes = {
  spinnerContainerClass: PropTypes.string,
  isLoading: PropTypes.bool,
  isAbsolute: PropTypes.bool,
  elementType: PropTypes.string,
  animation: PropTypes.string,
  size: PropTypes.string,
  colorVariant: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.func,
};

Spinner.defaultProps = {
  isLoading: false,
  isAbsolute: false,
  elementType: 'div',
  animation: 'border',
  colorVariant: 'primary',
};

export default Spinner;
